import script from "./AddressSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressSearch.vue?vue&type=script&setup=true&lang=js"

import "./AddressSearch.vue?vue&type=style&index=0&id=c8031a84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8031a84"]])

export default __exports__